/** Copy of the boxes page (Operations), ported from VentaHub. */
export const boxes = {
  title: 'Box detail',
  description: 'The boxes in a warehouse, and where each one has got to.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'Boxes are listed one warehouse at a time.',
  empty: 'No boxes match',
  emptyHint: 'Widen the filters, or check the warehouse.',
  download: 'Download boxes',
  viaVendorOrder: 'via vendor order',
  viaVendorOrderHint:
    "Reached through this box's vendor order — the box itself is not mapped to this PO. Clearing the PO's box mapping won't remove this link.",
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    boxes: 'Box codes',
    skus: 'SKU codes',
    status: 'Status',
    dates: 'Received',
    nonEmpty: 'Hide empty boxes',
    netBlocked: 'Take blocked out of quantity',
    vendor: 'Vendor',
    retailer: 'Retailer',
    invoice: 'Sales invoice',
    vendorInvoice: 'Vendor invoice',
    po: 'Purchase order',
    note: 'Credit/debit note',
    currency: 'Currency',
  },
  status: {
    inward: 'Inward',
    allotted: 'Allotted',
    billed: 'Billed',
    dispatched: 'Dispatched',
    delivered: 'Delivered',
  },
  columns: {
    box: 'Box',
    status: 'Status',
    vendor: 'Vendor',
    vendorInvoice: 'Vendor invoice',
    po: 'Purchase order',
    invoice: 'Invoice',
    note: 'Credit/debit note',
    retailer: 'Retailer',
    quantity: 'Quantity',
    blocked: 'Blocked',
    skus: 'SKUs',
    value: 'Value',
  },
  open: 'Open box {{code}}',
  tickAll: 'Select every box on this page',
  tickRow: 'Select box {{code}}',
  getChecked: 'Get checked box details',
  getCheckedCount_one: 'Get details for {{count}} checked box',
  getCheckedCount_other: 'Get details for {{count}} checked boxes',
  contentsTitle: 'Box contents',
  contentsTitleBulk_one: 'Contents of {{count}} checked box',
  contentsTitleBulk_other: 'Contents of {{count}} checked boxes',
  contentsDescription: 'The SKUs in this box and how much of each is blocked.',
  noContents: 'This box is empty.',
  noContentsHint: 'Nothing is in it now: it was never filled, or everything in it has gone out.',
  contents: {
    box: 'Box',
    sku: 'SKU',
    name: 'Name',
    quantity: 'Quantity',
    blocked: 'Blocked',
    expiry: 'Expiry',
  },
} as const
